<template>
    <el-container class="page-x" direction="vertical">
        <div class="search-x">
            <div class="search-item">
                <span class="label">网点名称</span>
                <el-input class="input-box" clearable v-model.trim="searchBox.likeHospName" placeholder="请输入网点名称"></el-input>
            </div>
            <div class="search-item">
                <span class="label">地区</span>
                <el-cascader v-model="searchBox.areaId" 
                    clearable
                    placeholder="请选择" 
                    :options="provinceFilterList" 
                    :props="propFilters" />
            </div>
            <div class="search-item">
                <span class="label">状态</span>
                <el-select
                    v-model="searchBox.status"
                    clearable
                    :placeholder="'请选择状态'"
                >
                    <el-option label="启用" value="ON"></el-option>
                    <el-option label="停用" value="OFF"></el-option>
                </el-select>
            </div>
            <!--v-auth="'sw_operate_log_index'"-->
            <el-button v-auth="'sa_hospital_page'" type="primary" class="search-btn" @click="searchData">查询</el-button>
            <el-button class="search-btn" v-auth="'sa_item_page'" type="primary" @click="() => $root.showPage = false">重置</el-button>
            <el-button v-auth="'sa_hospital_create'" type="warning" class="search-btn" @click="showVisibleAdd">新建</el-button>
            <el-button v-auth="'sa_hospital_import'" type="primary" class="search-btn" @click="dialogVisibleImport=true">批量导入</el-button>
            <el-button v-auth="'sa_hospital_import'" type="primary" class="search-btn" @click="exportWebsites">批量导出</el-button>
            <el-button class="search-btn fr" @click="goBack">返回</el-button>

        </div>
       
        <div class="table-x" ref="tableBox">
            <el-table v-loading="loading"
                      :data="tableData"
                      border
                      :height="tableHeight"
                      class="mb20">
                <el-table-column type="index"
                                 align="center"
                                 label="序号"
                                 width="80px">
                </el-table-column>
                <el-table-column prop="hospName"
                                 align="center"
                                 label="网点名称">
                </el-table-column>
                <el-table-column prop="province"
                                 align="center"
                                 label="所在省">
                </el-table-column>
                <el-table-column prop="city"
                                 align="center"
                                 label="所在市">
                </el-table-column>
                <el-table-column prop="area"
                                 align="center"
                                 label="所在县/区">
                </el-table-column>
                <el-table-column prop="thirdHospId"
                                 align="center"
                                 label="第三方网点编码">
                </el-table-column>
                <el-table-column prop="hospAddress"
                                 align="center"
                                 label="网点地址">
                </el-table-column>
                <el-table-column prop="hospMobile"
                                 align="center"
                                 label="网点电话">
                </el-table-column>
                <el-table-column label="状态"
                                 align="center"
                                 width="80px">
                    <template slot-scope="scope">
                        {{scope.row.hospStatus == 'ON' ? '启用' : '停用'}}
                    </template>
                </el-table-column>
                <el-table-column label="操作"
                                 align="center">
                    <template slot-scope="scope">
                        <el-button-group>

                            <el-button v-auth="'sa_provider_edit'" type="text" size="middle" class="table-btn" @click="operationHandle(scope.row)">编辑</el-button>

                            <el-button v-auth="'sa_service_status'" type="text" size="middle" class="table-btn" @click="changeStatus(scope.row, scope.row.hospStatus)">
                                {{scope.row.hospStatus == 'ON' ? '停用' : '启用'}}
                            </el-button>

                            <el-button v-auth="'sa_hospital_delete'" type="text" size="middle" class="table-btn" @click="delWebsite(scope.row)">删除</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页部分 -->
        <div class="pagination mb20">
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page="searchBox.pageNo"
                @size-change="handleSizeChange"
                :page-sizes="[10,50,100]"
                :page-size="searchBox.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
                > 
            </el-pagination>
        </div>

        <!-- 新增 -->
        <el-dialog 
            :title="visibleText" 
            :visible.sync="dialogVisibleAdd" 
            center 
            class="area-dialog"
            :destroy-on-close="true"
            :close-on-click-modal="false"
            @close="toCloseDialog">
            <el-form ref="formAdd" :model="formData" :rules="formRules" label-width="160px">
                <el-form-item label="供应商名称">
                    <span>{{providerAbbr}}</span>
                </el-form-item>
               <el-form-item label="网点名称" prop="hospName">
                    <el-input v-model.trim="formData.hospName" 
                              clearable placeholder="请输入网点名称，限制50个字符" maxlength="50"></el-input>
                </el-form-item>
                
                <el-form-item label="所在城市" prop="areaId">
                    <el-cascader v-model="formData.areaId" 
                        clearable
                        ref="cascader"
                        placeholder="请选择" 
                        :options="provinceList2" 
                        @change="handleItemChange" 
                        :props="props2" />
                </el-form-item>

                <el-form-item label="第三方网点编码" prop="thirdHospId">
                    <el-input v-model.trim="formData.thirdHospId" 
                              clearable placeholder="请输入第三方网点编码，限制50个字符" maxlength="50"></el-input>
                </el-form-item>
                
                <el-form-item label="网点地址" prop="hospAddress">
                    <el-input v-model.trim="formData.hospAddress" 
                              type="textarea"
                              clearable
                              show-word-limit
                              placeholder="请输入网点地址" maxlength="100"></el-input>
                </el-form-item>

                <el-form-item prop="hospStatus" label="状态">
                    <el-radio-group v-model="formData.hospStatus">
                        <el-radio label="ON">启用</el-radio>
                        <el-radio label="OFF">停用</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="网点电话" prop="hospMobile">
                    <el-input v-model.trim="formData.hospMobile" 
                              clearable placeholder="请输入网点电话" maxlength="11"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button class="search-btn" @click="toCloseDialog">取 消</el-button>
                <el-button type="primary" class="search-btn" @click="addWebsite">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 批量导入 -->
        <el-dialog 
            title="导入网点" 
            :visible.sync="dialogVisibleImport"
            center
            class="edit-dialog"
            :close-on-click-modal="false"
            @closed="toCloseDialogImport">
            <el-form ref="templateForm" :model="templateForm" label-width="120px">
                <el-form-item label="下载模板：">
                    <!-- <el-button type="primary" class="search-btn" @click="downloadTemp">下载模版</el-button> -->
                    <el-button type="primary" class="search-btn"><a class="no-a" :href="`${path}excel/供应商服务网点导入模板.xlsx`">下载模版</a></el-button>
                </el-form-item>
                
                <el-form-item label="选择上传文档：">
                    <el-upload class="upload-dom" ref="upload-dom" 
                              :data="templateForm" 
                              :action="uploadAction" 
                              :headers="uploadHeader"
                              :limit="1" 
                              :auto-upload="false" 
                              :on-change='uploadChange' 
                              :before-remove="uploadBeforeRemove" 
                              :on-success="uploadSucess" 
                              :on-remove="uploadHandleRemove" 
                              :before-upload="uploadBefore" 
                              accept=".xlsx" style="width: 55%">
                        <el-button type="primary"  icon="el-icon-upload">上传附件</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="search-btn" @click="toCloseDialogImport">取消</el-button>
                <el-button class="search-btn" type="primary" @click="sureSubmit('templateForm')">确定</el-button>
            </div>
        </el-dialog>
        <ImportFail :show="showImportFail" title="导入网点" :failObj="errorData" @receive="getReceive" />
    </el-container>
</template>

<script>
    import supplierArea from '@/assets/js/supplierArea.mixin'
    import cascader from '@/assets/js/cascader.mixin'
    import db from '@/assets/js/localstorage';
    import ImportFail from './components/ImportFail'
    import { dateFormat } from "@/assets/js/until.js";
    import { mapGetters } from "vuex";
    export default {
        name: 'WebsiteManager',
        mixins: [cascader,supplierArea],
        components: {
            ImportFail
        },
        data() {
            return {
                providerAbbr: this?.$route?.query?.providerAbbr, // 供应商简称
                path: process.env.BASE_URL,
                providerId: "",
                searchBox: {
                    likeHospName: '',
                    pageNo: 1,
                    pageSize: 10
                },
                tableHeight: 0,
                loading: false,
                tableData: [],
                total: 0,

                // 新增、编辑网点
                dialogVisibleAdd: false, // 弹窗是否展示
                dialogTypeAdd: 1, // 弹窗类型 1-新增 2-编辑 3-查看
                formData: {
                    areaId: '',
                    hospAddress: '',
                    hospMobile: '',
                    hospName: '',
                    thirdHospId: '',
                    hospStatus: 'ON'
                },
                formRules: {
                    hospName: [{ required: true, message: '请输入网点名称', trigger: 'blur' }],
                    thirdHospId: [{ required: true, message: '请输入第三方网点编码', trigger: 'blur' }],
                    areaId: [{ required: true, message: '请选择所在城市', trigger: 'change' }],
                    hospAddress: [{ required: true, message: '请输入网点地址', trigger: 'blur' }],
                },
                provinceList2: [], // 所在城市
                props2: {
                    lazy: true,
                    lazyLoad: this.cascaderLazyload,
                    children: "cities",
                    label: "name",
                    value: "id",
                },

                // 导入网点
                uploadHeader: { token: db.get('ACCESS_TOKEN') }, //上传header
                uploadFile: null, //上传后文件
                uploadAction: "", //提交表单地址
                dialogVisibleImport: false, // 弹窗是否展示
                templateForm: {
                    tempFile: ""
                },
                showImportFail: false,
                errorData: {}
            }
        },
        computed: {
            visibleText() {
                var str
                switch (this.dialogTypeAdd) {
                    case 1:
                        str = '新增'
                        break;
                    case 2:
                        str = '编辑'
                        break;
                    case 3:
                        str = '查看'
                        break;
                }
                return str + '网点'
            },
            ...mapGetters(["userName"]),
        },
        created(){
            let name = this.$route.query.providerAbbr
            let breadList = [
                {name: '供应商', link: ''},
                {name: '供应商管理', link: ''},
                {name: `【${name}】网点管理`, link: ''}
            ]
            // if (this.providerAbbr) {
            //     breadList.push({
            //         name: this.providerAbbr,
            //         link: ''
            //     })
            // }
            this.providerId = this.$route.query.id;
            this.$root.breadList = breadList
        },
        mounted() {
            this.$nextTick(() => {
                this.getData();
                this.getAreaTopList2();
                this.uploadAction = this.getApiUrl('postHospitalImport')+'?providerId='+ this.providerId;
            });
        },
        methods: {
            /**
             * 窗口改变重新获取高度
             */
            listenWindow() {
                this.tableHeight = this.$refs.tableBox.offsetHeight;
                window.addEventListener('resize', ()=>{
                    clearTimeout(this.resizeFlag)
                    this.resizeFlag = setTimeout(() => {
                        try{
                            this.tableHeight = this.$refs.tableBox.offsetHeight || 0;
                        }catch(e){}
                    }, 300);
                })
            },
            getReceive(data) {
                this[data.key] = data.value
            },
            // -- 启用 && 停用
            changeStatus(row, status) {
                var text = "";
                if (status == 'ON') {
                    text = "停用";
                } else {
                    text = "启用";
                }
                this.$confirm("您是否确定"+text+"?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }).then(() => {
                        let params = {
                            id: row.id,
                            status: status == 'ON' ? 'OFF' : 'ON'
                        }
                        this.axios
                            .post(this.getApiUrl('postHospitalStatus'), params, { toJSON: true })
                            .then(res => {
                                if (res.code == 1) {
                                    this.$message({
                                        type: "success",
                                        message: text + '成功'
                                    });
                                    this.getData()
                                }else {
                                    this.$message.warning(res.msg);
                                }
                            });
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消操作"
                        });
                    });
            },
            /**
             * 新增
             */
            showVisibleAdd() {
                this.formData = {
                    areaId: '',
                    hospAddress: '',
                    hospMobile: '',
                    hospName: '',
                    thirdHospId: '',
                    hospStatus: 'ON'
                }
                this.dialogTypeAdd = 1
                this.dialogVisibleAdd = true
            },
            /**
             * 编辑
             */
            async operationHandle(row) {
                const res = await this.axios
                    .get(this.getApiUrl("postHospitalView"),{
                        params: {
                            hospitalId: row.id
                        }
                    })
                this.formData = Object.assign({},res.data,{id:row.id})
                this.dialogTypeAdd = 2
                this.dialogVisibleAdd = true;
                this.$nextTick(() => {
                    // 由于element没有提供异步加载的回显功能，所以每次编辑时，通过查找dom进行修改所在城市值（只用作编辑回显，不影响数据）
                    try {
                        this.$refs.cascader.$el.getElementsByTagName('input')[0].value = row.province + ' / ' + row.city + ' / ' + row.area
                    } catch (error) {
                        console.log(error)
                    }
                })
            },
            async saveEdit() {
                const res = await this.axios
                    .post(this.getApiUrl("serviceEdit"), { 
                    }, { toJSON: true })
                    console.log(res.data)
            },

            deletHandle(row) {
                console.log(row);
                this.$confirm('确认删除该服务?', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            goBack() {
                this.$router.go(-1);
            },
            getAreaTopList2() {
                this.axios
                    .get(this.getApiUrl("areaTopList"))
                    .then((res) => {
                        this.loading = false;
                        if (res.code === 1) {
                            this.provinceList2 = res.data || [];
                        } else {
                            this.$message.warning(res.msg);
                        }
                    })
                    .catch((err) => {
                        this.loading = false;
                        console.log(err);
                    });
            },
            searchData() {
                this.searchBox.pageNo = 1;
                this.getData();
            },
            getData(){
                this.loading = true;
                let params = {
                    ...this.searchBox,
                    ...this.getAreaIdObj(this.searchBox),
                    providerId: this.providerId
                }
                this.axios
                    .get(this.getApiUrl("hospitalPage"), { params })
                    .then((res) => {
                        this.loading = false;
                        if (res.code === 1) {
                            this.tableData = res.data.data || [];
                            this.total = res.data.total;
                        } else {
                            this.$message.warning(res.msg);
                        }
                    })
                    .catch((err) => {
                        this.loading = false;
                        console.log(err);
                    });
                this.listenWindow()
            },
            handleCurrentChange (val){
                this.searchBox.pageNo = val;
                this.getData();
            },
            handleSizeChange(val) {
                this.searchBox.pageNo = 1;
                this.searchBox.pageSize = val;
                this.getData();
            },
            // 删除表格行数据
            delWebsite(row) {
                this.$confirm("您是否确定删除?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }).then(() => {
                        this.axios
                            .post(this.getApiUrl('postHospitalDelete'), { 
                                id: row.id
                            }, { toJSON: true })
                            .then(res => {
                                if (res.code == 1) {
                                    this.$message({
                                        type: "success",
                                        message: "删除成功"
                                    });
                                    this.getData()
                                }else {
                                    this.$message.warning(res.msg);
                                }
                            });
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消操作"
                        });
                    });
            },

            /**
             * 弹窗相关 **/
            addWebsite() {
                this.$refs['formAdd'].validate((valid) => {
                    if(!valid){
                        return false
                    }
                    this.submitLoading = true;
                    let params = {
                        ...this.formData,
                        providerId: this.providerId
                    }
                    let api = {
                        1: 'postHospitalCreate',
                        2: 'postHospitalEdit'
                    }[this.dialogTypeAdd]
                    this.axios
                        .post(this.getApiUrl(api),  params, { toJSON: true })
                        .then(res => {
                            this.submitLoading = false;
                            if(res.code === 1) {
                                this.getData();
                                this.$message.success(res.msg);
                                this.toCloseDialog();
                            }else {
                                this.$message.error(res.msg);
                            }
                        })
                        .catch(err => {
                            this.submitLoading = false;
                            console.log(err)
                        })
                })
            },
            handleItemChange(val) { 
                // console.log(val)
                this.formData.areaId = val[2]
            },
            // 关闭弹窗，重置rule
            toCloseDialog() {
                this.$refs.formAdd.resetFields();
                this.dialogVisibleAdd = false;

            },

            /**
             * 导入网点**/ 
            //下载模板
            downloadTemp() {
                this.http
                    .exportExcel(this._apiCore.sysNetworkExcelTemplate, null, "get")
                    .then(res => {
                        if (res.code == 1) {
                            const blob = new Blob([res.data]);
                            var fileName = "网点模版" + ".xlsx";
                            const elink = document.createElement("a");
                            elink.download = fileName;
                            elink.style.display = "none";
                            elink.href = URL.createObjectURL(blob);
                            document.body.appendChild(elink);
                            elink.click();
                            URL.revokeObjectURL(elink.href);
                            document.body.removeChild(elink);
                            this.$message({
                                message: "下载成功",
                                type: "success"
                            });
                        } else {
                            this.$message.error("下载失败，请稍后再试");
                        }
                    });
            },
            // -- 文件上传确定按钮
            sureSubmit(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        if (!this.uploadFile) {
                            this.$message.warning("请选择文件");
                            return;
                        }
                        //数据确认
                        this.$refs["upload-dom"].submit();
                    } else {
                        return false;
                    }
                });
            },
            //文件状态改变时
            uploadChange(file) {
                this.uploadFile = file;
            },
            //文件移除前
            uploadBeforeRemove(file) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            //文件上传前
            uploadBefore(file) {
                const isLt10M = file.size / 1024 / 1024 < 10;
                if (!isLt10M) {
                    this.$message.error("上传文件不能超过 10MB!");
                }
                return isLt10M;
            },
            //文件移除
            uploadHandleRemove() {
                this.uploadFile = null;
                this.$refs["upload-dom"].clearFiles();
            },
            //文件上传成功
            uploadSucess(res) {
                let { code, msg } = res;
                if (code == 1) {
                    this.doErrorData(res.data)
                } else {
                    this.$message.error(msg);
                }
                this.uploadHandleRemove()
            },
            doErrorData(res) {
                if(res.failList && res.failList.length == 0) {
                    this.$message({
                        type: "success",
                        message: "导入成功"
                    });
                    this.dialogVisibleImport = false
                }else{
                    res.failList =res.failList.map(item => {
                        return Object.keys(item).map((el) => {
                            return {
                                value: el,
                                label: item[el]
                            }
                        })[0]
                    })
                    res.fileName = "供应商网点导入失败信息表"
                    res.headerData = 3 // 3为供应商网点表头信息
                    this.errorData = res;
                    this.showImportFail = true;
                }
                this.getData();
            },
            toCloseDialogImport() {
                this.uploadFile = null;
                this.dialogVisibleImport = false;
                this.$refs["upload-dom"].clearFiles();
                this.$refs["templateForm"].resetFields();
            },
            // 导出网点
            exportWebsites() {
                let urlPath = this.getApiUrl("hospitalExport")
                let date = dateFormat(new Date())
                let params = {
                    providerId: this.providerId,
                    ...this.searchBox,
                    ...this.getAreaIdObj(this.searchBox)

                }
                let param = this.$root.optionProcess(JSON.parse(JSON.stringify(params)))
                if(param.areaId) delete param.areaId
                delete param.pageNo;
                delete param.pageSize;
                let fileName = `${this.$route.query.providerAbbr}网点信息${date.replace(/-/g,"").slice(0,8)}${this.userName}`
                this.$root.exportFile(urlPath,param,fileName)
            },
        },
        beforeRouteLeave(to, from, next) {
            // this.$root.savePageCache(Object.assign({},this.searchBox,this.getAreaIdObj(this.searchBox)))
            if(to.name != "SupplierManager"){ 
                this.$root.removeCache('supplierQuery')
            }else{
                to.meta.keepAlive = true
            }
            next(true);
        },

    }
</script>

<style lang="scss" scoped type="text/scss">
.no-a {
    color: #fff;
    text-decoration: none;
}
.area-dialog {
    .el-input, .el-textarea, .el-cascader{
        width: 300px;
    }
}
</style>
<style lang="scss"> 
.el-message-box_style {
    .el-message-box__title {
        color: #f56c6c!important;
    }
}
</style>